// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"ece31a9c","372":"f4e57ea0","488":"16a42a2f","712":"e6f10a21"}[chunkId] + ".chunk.js";
};